import { JiraSoftwareIcon, JiraWorkManagementIcon } from "@atlaskit/logo";

import {
    ProductKeys,
    TemplateChoiceCategory,
    TemplateChoiceStaticContent,
    TemplateKeys,
    TemplateKeysType
} from "../../models/percieved-provisioning";

import messages from "./messages";

const businessImg =
    "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-business-card-header.webp";
const kanbanImg =
    "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-kanban-card-header.webp";
const scrumImg =
    "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-scrum-card-header-update.webp";

export const RESPONSIVE_SCREEN_HEIGHT_THRESHOLD = 760;
export const RESPONSIVE_SCREEN_WIDTH_THRESHOLD = 1530;

export const PACKAGE_NAME_KEBAB =
    "bxpkit-wac-confirmation-page.perceived-provisioning";

export const TEMPLATE_CHOICE_BOARD_TEST_ID = `${PACKAGE_NAME_KEBAB}.ui.onboarding-manager.template-choice.body.board`;
export const TEMPLATE_CHOICE_HEADER_TEST_ID = `${TEMPLATE_CHOICE_BOARD_TEST_ID}.header`;
export const TEMPLATE_CHOICE_CARD_TEST_ID = `${TEMPLATE_CHOICE_BOARD_TEST_ID}.card`;

export const LOADING_STATE_TEST_ID = `${PACKAGE_NAME_KEBAB}.ui.loading-state`;

const TemplateCardStatus = {
    POPULAR: messages.statusPopular
};

const kanbanTemplateContent: TemplateChoiceStaticContent = {
    key: TemplateKeys.KANBAN,
    cardType: "kanban",
    title: messages.kanbanCardName,
    iconSrc: kanbanImg,
    iconBackground:
        "linear-gradient(to bottom right, rgba(231, 240, 254, 1) 0%, rgba(160, 193, 244, 1) 100%)",
    summary: messages.kanbanCardSummary,
    description: messages.kanbanCardDescriptionText,
    status: TemplateCardStatus.POPULAR
};

const scrumTemplateContent: TemplateChoiceStaticContent = {
    key: TemplateKeys.SCRUM,
    cardType: "scrum",
    title: messages.scrumCardName,
    iconSrc: scrumImg,
    iconBackground:
        "linear-gradient(190deg, rgba(221, 233, 253, 1) 0%, rgba(182, 208, 248, 1) 50%, rgba(125, 169, 238, 1) 100%)",
    summary: messages.scrumCardSummary,
    description: messages.scrumCardDescriptionText
};

const businessBlankTemplateContent: TemplateChoiceStaticContent = {
    key: TemplateKeys.BUSINESS,
    cardType: "business",
    title: messages.businessCardName,
    iconSrc: businessImg,
    iconBackground:
        "linear-gradient(135deg, rgba(166, 230, 202, 1) 0%, rgba(187, 238, 216, 1) 30%, rgba(220, 249, 236, 1) 100%)",
    summary: messages.businessCardSummary,
    description: messages.businessCardDescription
};

export const TemplateStaticContent: Record<
    TemplateKeysType,
    TemplateChoiceStaticContent | undefined
> = {
    [TemplateKeys.KANBAN]: kanbanTemplateContent,
    [TemplateKeys.SCRUM]: scrumTemplateContent,
    [TemplateKeys.BUSINESS]: businessBlankTemplateContent,
    [TemplateKeys.UNKNOWN]: undefined
};

export const JSWCategory: TemplateChoiceCategory = {
    name: ProductKeys.JSW,
    displayName: messages.softwareBoardTitle,
    logoComponent: <JiraSoftwareIcon appearance="inverse" size="xxsmall" />,
    templateKeys: [TemplateKeys.KANBAN, TemplateKeys.SCRUM]
};

export const JWMCategory: TemplateChoiceCategory = {
    name: ProductKeys.JWM,
    displayName: messages.businessBoardTitle,
    logoComponent: (
        <JiraWorkManagementIcon appearance="inverse" size="xxsmall" />
    ),
    templateKeys: [TemplateKeys.BUSINESS]
};
